module.exports = __webpack_public_path__ + "img/discussion-icon-left.42c29db4.png";